export default "__VITE_ASSET__CAW7bj5U__"